import { buildApiUrl } from "../utils/apiConfig";
import { apiClient } from "../utils/apiClient";

export type CompleteCoursePayload = {
    courseId: number;
    courseName: string;
    courseImageUrl?: string | null;
    title: string;
    description: string;
    dueAt?: string;
    allDay?: boolean;
};

export type CompleteCourseResponse = {
    id: number;
    courseId: number;
    completed: boolean;
};

export async function completeCourse(payload: CompleteCoursePayload): Promise<CompleteCourseResponse> {
    const response = await apiClient(buildApiUrl("/api/tasks/complete-course"), {
        method: "POST",
        credentials: "include",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            courseId: payload.courseId,
            courseName: payload.courseName,
            courseImageUrl: payload.courseImageUrl ?? null,
            title: payload.title,
            description: payload.description,
            dueAt: payload.dueAt,
            allDay: payload.allDay ?? true,
        }),
    });

    if (!response.ok) {
        let message = "Failed to mark course complete";
        try {
            const data = await response.json();
            message = data.message || data.detail || message;
        } catch {
            // ignore
        }
        throw new Error(message);
    }

    return response.json();
}

export function buildCourseCompletionPayload(course: {
    id: number;
    title: string;
    featuredImageUrl?: string;
    courseImageUrl?: string;
}): CompleteCoursePayload {
    const imageUrl = "featuredImageUrl" in course ? course.featuredImageUrl : course.courseImageUrl;
    return {
        courseId: course.id,
        courseName: course.title,
        courseImageUrl: imageUrl ?? null,
        title: `Complete: ${course.title}`,
        description: `Complete the ${course.title} course`,
        allDay: true,
    };
}
